/**********************************************************
 * Config
 **********************************************************/

const FEATURE_TOGGLES = {
	LIVE: true // enable live updates using server-sent events
};

/**
 * List of competitions (key in array is year modulo 4)
 */
const COMPETITIONS = ['euro', 'cwc', 'worldcup'];

/**
 * Support query parameter override for feature toggles: ?OV_LIVE=true
 */
const overrides = Object.fromEntries(
	Array.from(new URLSearchParams(window.location.search).entries())
		.filter(([k]) => k.startsWith('OV_'))
		.map(([k, v]) => [k.slice(3), v])
);

function isEnabled(ft) {
	const override = overrides[ft];
	return override ? (/^TRUE$/i).test(override) : !!FEATURE_TOGGLES[ft];
}

export const config = {
	url: {
		templates: 'app.json',
		data: (year) => `api/${year}/data/all`,
		editMatch: (year, mid, score1, score2, score1PK, score2PK) =>
			`api/${year}/edit/editMatch?mid=${mid}&score1=${score1}&score2=${score2}&score1PK=${score1PK}&score2PK=${score2PK}`,
		setRanks: (year, gid, ranks) => `api/${year}/edit/setRanks?gid=${gid}&ranks=${ranks}`,
		betOnChampion: (year, teamId) => `api/${year}/bet/champion?champion=${teamId}`,
		betOnMatchWinner: (year, mid, teamId) => `api/${year}/bet/match?mid=${mid}&winner=${teamId}`,
		live: 'api/live',
		logout: 'api/user/logout',
		login: 'api/user/login',
		register: 'api/user/register',
		auth: (provider) => `api/auth/url?provider=${provider}`,
		authProfile: (code) => `api/auth/profile?code=${code}`
	},
	getCompetitionId: (year) => COMPETITIONS[year % 4],
	phases: ['G', 'B', 'J', 'H', 'Q', 'S', 'T', 'F'],
	i18n: {
		names: {
			cwc: (year) => `${year} FIFA Club World Cup`,
			euro: (year) => `UEFA Euro ${year}`,
			worldcup: (year) => `${year} FIFA Worldcup`,
		},
		title: (name, state) => `${name} - ${state}`,
		group: (group) => `Group ${group}`,
		phaseG: 'Group Matches',
		phaseB: 'Second Round',
		phaseJ: 'Round of 32',
		phaseH: 'Round of 16',
		phaseQ: 'Quarter-Finals',
		phaseS: 'Semi-Finals',
		phaseT: 'Third place',
		phaseF: 'Final',
		formats: {
			date: new Intl.DateTimeFormat('en-GB', { dateStyle: 'full' })
		}
	},
	area: {
		main: 'global-container',
		pwl: 'app-pwl',
		contents: 'contents',
		user: 'user-area',
		loginDlg: 'login-dlg',
		liveMatch: 'live-match'
	},
	defaultYear: '2026',
	defaultPage: 'schedule',
	lang: 'en-GB',
	ft: { // Feature Toggles
		get LIVE() { return isEnabled('LIVE'); }
	}
};
